import { useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';
import { SearchType, SearchTypeLiteral } from 'shared/src/api/enums';
import { searchHelperParamsAtom } from '../states/searchHelperParams.atom';

type SearchKeywordLogParams = {
  /** SearchType enum 값 */
  searchType: SearchType;
  /** 검색어 (SEARCH_KEYWORD) */
  keyword: string;
};

export const useLogClickRemoveKeyword = () => {
  const params = useAtomValue(searchHelperParamsAtom);
  const isTodaySearch =
    params.delivery_type === 'today' ||
    params.delivery_type === 'shak' ||
    params.delivery_type === 'fast'
      ? '1'
      : '0';
  const logAnalyticsEvent = useLogAnalyticsEvent();

  const logRemoveKeyword = useCallback(
    ({ searchType, keyword }: SearchKeywordLogParams) => {
      const analytics: Record<string, unknown> = {
        SEARCH_TYPE: SearchTypeLiteral[searchType],
        SEARCH_KEYWORD: keyword,
        IS_TODAY_SEARCH: isTodaySearch,
      };

      logAnalyticsEvent({
        name: 'CLICK_REMOVE_KEYWORD',
        channel: ['firebase', 'amplitude', 'facebook', 'ablylog'],
        analytics,
        ably_only_log: {
          event_name: 'keyword_search',
          list_id: searchType.toLowerCase(),
          search_query: keyword,
        },
      });
    },
    [isTodaySearch, logAnalyticsEvent],
  );

  return logRemoveKeyword;
};
